module.exports = __webpack_public_path__ + "static/media/alcendino.70ac83a0.jpg";